import React from 'react';

import { NetSuiteRecordChip } from 'modules';
import { DateTime } from 'luxon';
import { useRmaSourceInformationWidgetQuery } from 'generated/graphql';



export interface IReturnAuthorization {
  clientName: string;
  rmaType: string;
  dateReceived: DateTime;
  netSuiteRecord: NetSuiteRecordChip.IWriteStatus;
  referenceNumber: string;
  inboundTrackingNumber: string;
}

export interface IData {
  returnAuthorization: IReturnAuthorization | null;
}

export function useQuery(returnAuthorizationId: string) {
  const tuple = useRmaSourceInformationWidgetQuery({
    variables: {
      returnAuthorizationId
    }
  });

  return React.useMemo(
    () => {
      const returnAuthorization = tuple.data?.tier1ReturnAuthorization;
      const data: IData = {
        returnAuthorization: returnAuthorization ? {
          clientName: returnAuthorization.group.store.name,
          dateReceived: DateTime.fromISO(returnAuthorization.createdTimestamp),
          inboundTrackingNumber: returnAuthorization.inboundTrackingNumber,
          netSuiteRecord: NetSuiteRecordChip.genWriteStatus({
            writeRequest: returnAuthorization.netSuiteWriteRequest,
            netSuiteRecord: returnAuthorization.netSuiteRecord
          }),
          referenceNumber: returnAuthorization.group.referenceNumber,
          rmaType: '-'
        } : null
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
